import React, { useContext, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import DefaultSpinner from './DefaultSpinner';
import PageLoadingContext from './PageLoadingContext';

const defaultRenderOnLoad = <DefaultSpinner />;

export default function Loading({ renderOnLoad = defaultRenderOnLoad }) {
    const registerPageLoading = useContext(PageLoadingContext);

    useLayoutEffect(() => registerPageLoading(), [registerPageLoading]);

    return renderOnLoad;
}

Loading.propTypes = {
    renderOnLoad: PropTypes.node,
};
